var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#a63040",
    viewBox: "-0.64 -0.64 17.28 17.28",
    id: "x-circle-16px",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#a63040",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M-16,0a8.009,8.009,0,0,0-8,8,8.009,8.009,0,0,0,8,8A8.009,8.009,0,0,0-8,8,8.009,8.009,0,0,0-16,0Zm0,15a7.008,7.008,0,0,1-7-7,7.008,7.008,0,0,1,7-7A7.008,7.008,0,0,1-9,8,7.008,7.008,0,0,1-16,15Zm3.854-10.146L-15.293,8l3.147,3.146a.5.5,0,0,1,0,.708A.5.5,0,0,1-12.5,12a.5.5,0,0,1-.354-.146L-16,8.707l-3.146,3.147A.5.5,0,0,1-19.5,12a.5.5,0,0,1-.354-.146.5.5,0,0,1,0-.708L-16.707,8l-3.147-3.146a.5.5,0,0,1,0-.708.5.5,0,0,1,.708,0L-16,7.293l3.146-3.147a.5.5,0,0,1,.708,0A.5.5,0,0,1-12.146,4.854Z",
    transform: "translate(24)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.2c824319ac6bd6279db3aad296e3d9af.svg";
export { ForwardRef as ReactComponent };